import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Undo2, PackagePlus } from "lucide-react";

export default function TriggerChooserDialog({ open, onOpenChange, orderId, onChoose }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="trigger-chooser-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading">Two follow-ups needed</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          This action for order{orderId ? ` #${orderId}` : ""} needs both a{" "}
          <span className="font-medium text-[#111411]">reverse pickup</span> and a{" "}
          <span className="font-medium text-[#111411]">new shipment</span>. What do you want to handle first?
          You can skip either step — it stays flagged in its queue for later.
        </p>
        <div className="grid gap-2 pt-1">
          <Button data-testid="chooser-rvp-first" onClick={() => onChoose("rvp_first")}
                  className="justify-start gap-2 bg-[#0B3D3D] hover:bg-[#0A2E2E] text-white">
            <Undo2 className="h-4 w-4" /> Reverse pickup first
          </Button>
          <Button data-testid="chooser-reship-first" onClick={() => onChoose("reship_first")}
                  variant="outline" className="justify-start gap-2">
            <PackagePlus className="h-4 w-4" /> New shipment first
          </Button>
          <Button data-testid="chooser-skip" onClick={() => onChoose("skip")}
                  variant="ghost" className="justify-start text-muted-foreground">
            Skip both for now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
